export default class FormSelectSP {
    constructor() {
        this.$selectSpRequired = $('#js-select-sp-required');
        this.$selectSpPassive = $("#js-select-sp-passive");
        this.y = '';
    }

    bindProcess() {
        this.check();

        this.$selectSpRequired.on('change',()=>{
            this.check();
        });

        $('.js-select-tag').on('change',(e)=>{
            let $current = $(e.currentTarget);
            let val = $current.val();
            let href = '';
            this.$currentSelect = $(e.currentTarget);

            $current.children('option').each((i, t)=>{
                let $t = $(t);
                if ($t.text() === val) {
                    href = $t.attr('data-href');
                }

            });
            if (href !== '') {
                location.href = href;
            } else {
                // スキップ
                // console.log('error href null');
            }

        });

        $('#js-select-sp-category').on('change', (e)=>{
            // TODO: カテゴリーのURLの変更はHTML側のval値
            let $current = $(e.currentTarget);
            let val = $current.val();
            let href = '';
            this.$currentSelect = $(e.currentTarget);

            $current.children('option').each((i, t)=>{
                let $t = $(t);
                if ($t.text() === val) {
                    href = $t.attr('data-href');
                }

            });
            if (href !== '') {
                location.href = href;
            } else {
                // スキップ
                // console.log('error href null');
            }
        });
    }

    check(){
        let val = this.$selectSpRequired.val();
        this.y = val;
        if (val === '') {
            this.$selectSpPassive.prop("disabled", true);
        } else {
            this.$selectSpPassive.prop("disabled", false);
        }
    }
}